import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines } from "../Reveal";

export const SectionHead = ({ kicker, title, to, light = false, testId }) => (
  <div className={`flex items-end justify-between gap-6 border-b-2 pb-5 mb-10 ${light ? "border-cream" : "border-ink"}`}>
    <div>
      <p className={`kicker mb-3 ${light ? "text-hot" : "text-rose"}`}>{kicker}</p>
      <h2 className={`display text-6xl sm:text-8xl lg:text-9xl ${light ? "text-cream" : "text-ink"}`}>
        <MaskLines lines={[title]} inView testId={testId} />
      </h2>
    </div>
    {to && (
      <Link to={to} className={`group shrink-0 inline-flex items-center gap-2 kicker rounded-full border px-4 py-2.5 transition-colors ${light ? "border-cream text-cream hover:bg-hot hover:border-hot hover:text-ink" : "border-ink hover:bg-ink hover:text-cream"}`} data-testid={`${testId}-view-all`}>
        View all <ArrowUpRight className="h-3.5 w-3.5 group-hover:rotate-45 transition-transform" />
      </Link>
    )}
  </div>
);
